export function* zip(...iterables) {
    // get the iterator of for each iterables
    const iters = [...iterables].map((iterable) => iterable[Symbol.iterator]());
    let next = iters.map((iter) => iter.next().value);

    // as long as all of the iterables return something, yield a value
    while (next.every((v) => v !== undefined)) {
        yield next;
        next = iters.map((iter) => iter.next().value);
    }
}

export function* zip_longest(...iterables) {
    // get the iterator of for each iterables
    const iters = [...iterables].map((iterable) => iterable[Symbol.iterator]());
    let next = iters.map((iter) => iter.next().value);

    // as long as any of the iterables returns something, yield a value (zip longest)
    while (next.some((v) => v !== undefined)) {
        yield next;
        next = iters.map((iter) => iter.next().value);
    }
}
